import { createContext, useContext } from 'react';
import { userFields, userTypes } from '../config/configUser';

export const ConfigurationContext = createContext();

export const ConfigurationProvider = ConfigurationContext.Provider;

export const useConfiguration = () => {
  const config = useContext(ConfigurationContext);
  const mergedConfig = { ...config, user: { ...config.user, userFields, userTypes } };
  // console.log({ config, mergedConfig });
  return mergedConfig;
};
